const toRouteRoleRegex = (path, roles = []) => {
	return `${roles.length ? `/:role(${roles.join('|')})` : ''}${path}`
}
export { toRouteRoleRegex }
